import { type FC } from 'react'
import { CookiePreferenceOptionContext } from './CookiePreferenceOption'
import type { CookiePreferencesProps } from './CookiePreferences.interface'
import styles from './CookiePreferences.module.scss'

export const CookiePreferences: FC<CookiePreferencesProps> = ({
  title,
  intro,
  statusHeading,
  preferences
}) => (
  <section>
    <div className="container">
      <section className={styles.container}>
        <h1 className={`${styles.title} title-sm`}>{title}</h1>
        <p className={styles.text}>{intro}</p>
        <h2 className={styles.subtitle}>{statusHeading}</h2>
        {preferences.map((preference) => (
          <CookiePreferenceOptionContext
            key={preference.name}
            name={preference.name}
            isNecessary={preference.isNecessary}
            title={preference.title}
            description={preference.description}
            togglePreferenceCookie={(name: boolean): void => {
              // throw new Error('Function not implemented.')
            }}
          />
        ))}
      </section>
    </div>
  </section>
)
